// extracted by mini-css-extract-plugin
module.exports = {"img":"Loading_img__26VmZ","loadingImage":"Loading_loadingImage__16iBc"};